
const {ccclass, property} = cc._decorator;
/**
 * 漂浮效果
 */
@ccclass
export default class floatEffect extends cc.Component {

    @property({ displayName: '悬浮距离' }) private value: number = 15;
    @property({ displayName: '消耗时间', tooltip: '悬浮1/4距离消耗的时间' }) private time: number = 1;

    /** 编辑器预览 */
    private _edit_play: boolean = false;
    @property({ displayName: '编辑器预览' })
    get edit_play(): boolean {
        if (this._edit_play && !this.edit_playing) this.initShakeSlow();
        this.edit_playing = this._edit_play;
        return this._edit_play;
    }
    set edit_play(v: boolean) {
        this._edit_play = v;
        if (!v) this.stop();
    }

    /** 编辑器是否正在播放 */
    private edit_playing = false;

    onLoad() {

    }

    start() {
        if (CC_EDITOR) {
            if (this.edit_play) {
                this.initShakeSlow()
            }
        } else {
            this.initShakeSlow()
        }
    }

    /**
     * 缓动
     * @param node 动画节点
     */
    private initShakeSlow() {
        let node = this.node;
        let rotate1 = cc.tween().by(this.time, { position: { value: new cc.Vec2(0, this.value), easing: 'sineOut' } })
        let rotate2 = cc.tween().by(this.time, { position: { value: new cc.Vec2(0, 0), easing: 'sineIn' } })
        let rotate3 = cc.tween().by(this.time, { position: { value: new cc.Vec2(0, -this.value), easing: 'sineOut' } })
        let rotate4 = cc.tween().by(this.time, { position: { value: new cc.Vec2(0, 0), easing: 'sineIn' } })
        let sequence1 = cc.tween().sequence(rotate1, rotate2, rotate3, rotate4)
        cc.tween(node).then(sequence1).repeatForever().start();
    }

    /** 停止动画 */
    private stop() {
        this.node.stopAllActions();
    }

}
